export default "__VITE_ASSET__BB49S7W3__"